import React from "react";
import { TextFieldState, TextFieldProps, TextField } from './TextField'
import { FormItemProps } from './FormItem'
import { IField, getRequiredError, getMaxLengthError } from './FieldValidation';

export interface BankAccountNameProps extends FormItemProps {
    excludedAscii?: string,
    id: string
    disabled?: boolean
    // onChange: TextFieldCallback
    value: string
    maxLength?: number
    required?: boolean
    requiredMessage?: string
    regex?: string
    regexMessage?: string
    block?: boolean

}

export interface BankAccountNameState {
    value: string
    errorMessage?: string
}

export class BankAccountName<BankAccountNameProps, BankAccountNameState> extends TextField {

    getFieldType(): string {
        return "bankAccountName";
    }

    getErrorText(): string {
        let error = super.getErrorText();
        if (error) {
            return error;
        }

        if (this.hasValue()) {
            if (!/^([\w-+]+(?:\.[\w-+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,13}(?:\.[a-z]{2})?)$/i.test(this.getValue())) {
                return "Bank account name format is incorrect";
            }
        }

        return null;
    }
}
